if (!customElements.get('combined-bundle')) {
  class CombinedBundle extends HTMLElement {
    constructor() {
      super();
      
      this.mainID = 1;
      if (typeof window.bundleMainId !== 'undefined') {
        this.mainID = window.bundleMainId;
      } else {
        window.bundleMainId = 1;
      }
      this.set = [];
      this.cartDrawer = document.querySelector('cart-drawer');


      // Bind option select events
      this.querySelectorAll('[data-bundle-variant]').forEach((variant) => {
        variant.addEventListener('click', this.onBundleVariantSelect.bind(this));
      });

      // Bind add to cart
      let testMe = document.querySelector('[data-test-me]');
      testMe.addEventListener('click', this.addBundle.bind(this));

      document.querySelector('[data-test-me-two]').addEventListener('click', (event) => {
        testMe.click();
      });

      // preselect variants
      if (location.search.indexOf('colors=') > -1) {
        let arr = location.search.split('colors=');
        let unformatted = arr[1].split('?');
        let preformatted = unformatted[0].split('&')
        let formatted = preformatted[0];
        let idArr = [];
        if (formatted.indexOf('%2C') > -1) {
          idArr = formatted.split('%2C');
        } else {
          idArr = formatted.split(',');
        }
        let productArr = this.querySelectorAll('[data-total-bundle]');
        idArr.forEach((id, index) => {
          if (productArr[index]) {
            if (productArr[index].querySelector('[data-bundle-variant-id="' + id + '"]')) {
              productArr[index].querySelector('[data-bundle-variant-id="' + id + '"]').click();
            }
          }
        });
      }
    }

    /**
     * onBundleVariantSelect
     * @description Toggles variant switch for bundles
     */
    onBundleVariantSelect(event) {
      let target = event.target;
      if (typeof target.src === 'undefined') {
        target = event.target.querySelector('img');
      }
      let group = target.closest('[data-bundle-variant-group]');
      group.querySelector('.border-black').classList.add('border-black-50');
      group.querySelector('.border-black').classList.remove('border-black');
      target.closest('[data-bundle-variant]').classList.add('border-black');
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').src = target.src;
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').srcset = target.srcset;
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] span').innerHTML = target.alt;
    }

    addBundle(event) {
      let itemArr = event.target.closest('combined-bundle').querySelectorAll('[data-bundle-variant].border-black');
      itemArr.forEach((item) => {
        let id = item.dataset.bundleVariantId;
        this.set.push(id);
      });
      this.addSet();
    }

    addSet() {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
  
      const sectionsToFetch  = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
      ];
  
      let items = [];
      let object = {};

      let image = document.querySelector('[data-combined-bundle-image]').dataset.combinedBundleImage;
      let name = document.querySelector('[data-combined-bundle-name]').dataset.combinedBundleName;
      let elementData = document.querySelector('[data-combined-bundle-variant-id]').dataset;
      let variantID = elementData.combinedBundleVariantId;
      let discount = elementData.combinedBundleDiscount;
      let quantity = document.querySelector('.quantity__input').value;

      this.set.forEach((set) => {
        object = {};
        object = {
          quantity: parseInt(quantity),
          id: parseInt(set),
          properties: {
            "product_bundle": 'Bundle-' + this.mainID,
            "_product_bundle_discount": discount,
            "_product_bundle_image": image,
            "_product_bundle_name": name,
            "_product_bundle_variant_id": variantID
          }
        }
        items.push(object);
      });
  
      let body = JSON.stringify({
        items: items,
        sections: sectionsToFetch,
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => response.json())
        .then((parsedState) => {
    
          if (this.cartDrawer) {
            this.renderContents(parsedState);
          }

          document.body.classList.remove('product-bundle-is-open');
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.cartDrawer.open();
          this.mainID = this.mainID + 1;
          window.bundleMainId = this.mainID;
          this.set = [];
        });

    }

    renderContents(parsedState) {

      this.getSectionsToRender().forEach((section) => {
        if (section?.selector) {
          const selector = document.querySelector(section.selector);
          if (selector) {
            selector.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.id],
              section.selector
            );
          }
        }
      });

      this.handlePromos();

      this.cartDrawer.querySelectorAll('[data-cart-button-close]').forEach((btn) =>
        btn.addEventListener('click', this.close.bind(this))
      );
  
    }

    handlePromos() {
      if (document.querySelector('[data-product-drawer-promos]')) {
        let promos = document.querySelector('[data-product-drawer-promos]');
        if (promos.dataset && promos.dataset.productDrawerPromos) {
          let promoData = JSON.parse(promos.dataset.productDrawerPromos);
          let enable_promo = promoData.promo_enabled;
  
          if (enable_promo) {
            let promo_variant_id = promoData.promo_variant_id;
            let add_product = promoData.add_product;
  
            // add product
            if (add_product) {
  
              let properties = {};
              properties._promo_product = 'true';
              
              let body = JSON.stringify({
                id: promo_variant_id,
                quantity: 1,
                properties,
                sections: this.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname
              });
              
              fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
                .then((response) => response.json())
                .then((parsedState) => {
                  this.renderContents(parsedState);
                })
                .catch((e) => {
                  console.error(e);
                })
            }
          }
        }
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '[data-cart-drawer]',
        },
        {
          id: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        },
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    close() {
      document.body.classList.remove('cart-drawer-is-open');
      document.body.removeEventListener('click', this.onBodyClick);
    }

  }

  window.CombinedBundle = CombinedBundle;
  customElements.define('combined-bundle', CombinedBundle);
}
